module.exports = __webpack_public_path__ + "media/images/admin/fav-icon-adfb9b4cdb9565bae3e748d874d2b132.png";